import { INITIAL_STATE } from './state';
import { MessagesActions, } from './types';
export const reducer = (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case MessagesActions.SEND_EXTENSION_MESSAGE:
            return setExtensionMessage(state, payload);
        case MessagesActions.REMOVE_EXTENSION_MESSAGE:
            return removeExtensionMessage(state);
        default:
            return state;
    }
};
function setExtensionMessage(state, payload) {
    return {
        ...state,
        extensionMessage: payload,
    };
}
function removeExtensionMessage(state) {
    return {
        ...state,
        extensionMessage: null,
    };
}
